import React from 'react';
import '../../assets/css/components/form/icon-field.css'

// Simple input field designed to be compatible with react-form.
const InputField = props => {
  const { placeholder, error, hidden, input, label, name, type, wrapperClass, validate } = props

  return(
    <div className='icon-field'>
      <span className='input-group-addon primary bg-dark-tertiary'>
        <i className="fa fa-align-justify"></i>
      </span>
      <div className={`${type || 'text'} ${wrapperClass} input form-group form-group-default`}>
        {label && <label>{label}</label>}
        <input className='form-control no-box-shadow' id={name} {...input} type={type || 'text'} placeholder={placeholder} />
        {error && <span className='error'>{error}</span>}
      </div>
    </div>
  )
}

export default InputField
